<template>
    <div ref="wrapper">
        <slot></slot>
    </div>
</template>

<script>
import Scroll from './Scroll.js'
export default Scroll
</script>

<style scoped>
@import "./Scroll.scss";
</style>


// WEBPACK FOOTER //
// src/components/Scroll/Scroll.vue